export default __webpack_public_path__ + "static/hw_bme280-aadfa5b13ba3d30e23fe1127bedb8345.jpg";